import { getQueryVariable } from 'Utils/utils';

export default class EsignToolsPluginDocFns {
    constructor(fnMap) {
        this.fnMap = fnMap;
        this.addFn_GetSignatures = this.addFn_GetSignatures.bind(this);
    }



    registerFn() {
        this.addFn_GetSignatures();

    }

    addFn_GetSignatures() {
        this.fnMap['GetSignatures'] = async ({ resolve }) => {
            const curDocHash = getQueryVariable('curDocHash');
            let signaturesInfo;
            if (curDocHash) {
              signaturesInfo = sessionStorage.getItem(`auditTrailData_${curDocHash}_signaturesInfo`)
            }
            if (signaturesInfo) {
                signaturesInfo = JSON.parse(signaturesInfo)
            } else {
                let doc = await window.pdfui.getCurrentPDFDoc();
                const buffer = await doc.getOriginalStream();
                signaturesInfo = await doc.getDocAuditTrail(buffer)
                sessionStorage.setItem(`auditTrailData_${curDocHash}_signaturesInfo`, JSON.stringify(signaturesInfo))
            }
            const auth_inner = signaturesInfo.auth.filter(item=>item.method == 'SAML' || item.method == 'JWT');
            signaturesInfo.auth = auth_inner;
            resolve({
                ret: 0,
                data:signaturesInfo
            })
        };
    };
}